import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import 'rc-dropdown/assets/index.css';
import { faCaretDown, faCaretUp } from '@fortawesome/pro-solid-svg-icons';

const Index = ({
  selectedSortId,
  elementSortId,
  isAscending
}) => {
  
  return (
    <>
      <button className="assignment-sort-btn sort-btn row p-1 mt-2">
        <FontAwesomeIcon icon={faCaretUp} className={`${selectedSortId == elementSortId && isAscending ? 'enabled-caret' : ''}`} />
        <FontAwesomeIcon icon={faCaretDown} className={`align-caret-down ${selectedSortId == elementSortId && !isAscending ? 'enabled-caret' : ''}`} />
      </button>
    </>
  );
};

Index.propTypes = {
  selectedSortId: PropTypes.string,
  elementSortId: PropTypes.string,
  isAscending: PropTypes.bool
};

export default Index;
